import Vue from 'vue'

export default Vue.observable({
  messages: ['============== Audio AB testing =============='] as string[]
})
